import React from "react";
import { PointsWrapper, Parah, SubTitle, PointsIcon } from "../ContentsStyles";

const TAC_7 = () => {
  return (
    <>
      <SubTitle>What Happens When We Make Changes</SubTitle>
      <Parah>
        We may make changes to these Terms or the Platform from time to time. If
        we do, we will consider your reasonable interests before doing so.
      </Parah>
      <Parah>
        We will also give you reasonable advance notice, in a transparent
        manner, of significant changes which will impact you and the date that
        they will come into force. The changes will only apply to our
        relationship going forward.
      </Parah>
      <Parah>
        Where we need to make urgent changes for security, safety, legal or
        regulatory requirements, we may not be able to provide you with advance
        notice, but we will let you know as soon as we are able to.
      </Parah>
      <Parah>
        If you do not agree to the changes to the Terms or the Platform, you
        will have to stop using the Platform.
      </Parah>
      <Parah>
        In short: If these Terms change, we will tell you. It won’t change
        anything between us that has happened already but, if you want to keep
        using the Platform in the future, you will need to agree to the changes.
        Our Platform will evolve as we improve it.
      </Parah>
      <SubTitle>Reasons for Changes</SubTitle>
      <Parah>
        Reasons that we might make changes to these Terms or the Platform are:
      </Parah>
      <PointsWrapper>
        <PointsIcon /> Changes in circumstances beyond our reasonable control;
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> Changes in the law;
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> Changes we make to the Platform in the usual course of
        developing our product;
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> To adapt to new technologies;
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> To reflect changes in the number of people who use the
        Platform or any relevant feature or functionality of the Platform.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon /> To address a security issue.
      </PointsWrapper>
      <Parah>
        In short: Our Platform will not stay the same forever, but we will be
        transparent when we make major changes.
      </Parah>
    </>
  );
};

export default TAC_7;
